// API organizzazioni operatori economici — usa useHttp di Veda nei componenti,
// queste funzioni sono per chiamate fuori dal ciclo React (es. accettazione invito pre-login).

function backend() {
  return window.VEDA_API_URL || process.env.REACT_APP_BACKEND_URL || '';
}

async function getCsrfToken() {
  await fetch(`${backend()}/sanctum/csrf-cookie`, { method: 'GET', credentials: 'include' });
  return document.cookie
    .split('; ')
    .find((c) => c.startsWith('XSRF-TOKEN='))
    ?.split('=')[1] ?? '';
}

function headers(csrf) {
  return {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-XSRF-TOKEN': decodeURIComponent(csrf),
  };
}

/** Restituisce il dettaglio di un invito dato il token (pubblico, no auth). */
export async function getInvito(token) {
  const res = await fetch(`${backend()}/api/v1/operatore/inviti/${token}`, {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) throw new Error('Invito non trovato o scaduto.');
  return res.json();
}

/** Accetta l'invito dopo il login SPID/email (richiede autenticazione). */
export async function accettaInvito(token) {
  const csrf = await getCsrfToken();
  const res  = await fetch(`${backend()}/api/v1/operatore/inviti/${token}/accetta`, {
    method: 'POST',
    credentials: 'include',
    headers: headers(csrf),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body?.message ?? 'Errore durante l\'accettazione dell\'invito.');
  }
}
